import React from 'react';
import './styles.scss';
import { IconComponents } from './icons';
import { IconProps } from '@/types';

export type { IconProps };

export const Icon = (props: IconProps) => {
  const { name } = props;

  const IconComponent = IconComponents[name];

  if (!IconComponent) {
    return null;
  }

  return (
    <div className="peptalk-icon">
      <IconComponent {...props} />
    </div>
  );
};
